import { Pipe, PipeTransform } from '@angular/core';
import { TranslateOrDefault } from '@language';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateOrDefault',
    standalone: true,
    pure: true
})
export class TranslateOrDefaultPipe implements PipeTransform {
    constructor(private readonly translateService: TranslateService) {}

    transform(query: string, defaultValue?: string, params?: Record<string, string | number>): any {
        return TranslateOrDefault(this.translateService, query, defaultValue, params);
    }
}
